<div class="row space-between">
    @if (editMode === false) {
        <h2>Add new Stream</h2>
    } @else {
        <h2>Edit Stream</h2>
    }
</div>
<div class="configarea col gap-16 w100">
    <form [formGroup]="formGroup" class="w100 col gap-8">
        <app-cat-selection
            [initialValues]="categoryList"
            (categorieSelection)="addCategory($event)"
            class="catarea col gap-24 w100 card"
        ></app-cat-selection>
        <rr-checkbox
            formControlName="globalStream"
            [checked]="!!formGroup.value.globalStream"
            >Is this a Global Stream? (Visible to all users)</rr-checkbox
        >
        <rr-input
            formControlName="name"
            label="Name"
            [required]="true"
        ></rr-input>
        <rr-textarea
            formControlName="description"
            label="Description"
        ></rr-textarea>
        <rr-select
            label="LLM Model"
            [options]="llms"
            preselectedValue="K8Z4R2N7Q5"
            formControlName="llmId"
            optionName="name"
            [required]="true"
            optionValue="id"
        ></rr-select>
        <div class="row gap-8 w100">
            <rr-select
                label="Status"
                [options]="streamStatus"
                [required]="true"
                [formControl]="formGroup.controls.status"
                [preselectedValue]="
                    streamData?.status ? streamData.status : streamStatus[0].id
                "
                optionName="label"
                optionValue="id"
            ></rr-select>
            <rr-select
                label="Type"
                [options]="streamTypes"
                optionName="label"
                [required]="true"
                [preselectedValue]="
                    streamData?.type ? streamData.type : streamTypes[0].id
                "
                formControlName="type"
                optionValue="id"
            ></rr-select>
        </div>
        <rr-textarea
            label="Stream Goal"
            [required]="true"
            formControlName="streamGoal"
        ></rr-textarea>
    </form>
    <rr-divider></rr-divider>
    <form [formGroup]="formGroup" class="w100 col gap-8">
        <rr-checkbox formControlName="promotionStatus"
            >Show Promotion Area in the Stream?</rr-checkbox
        >
        <div
            class="videopanel col gap-16 w100"
            *ngIf="formGroup.controls.promotionStatus?.value === true"
        >
            <div class="row space-between align-center w100">
                <h3>Video-Panel</h3>
            </div>
            <div class="listvideos w100">
                @for (
                    video of promotionAreaVideos;
                    track video.url;
                    let i = $index
                ) {
                    <div
                        class="videocontainer card row space-between gap-8 w100"
                    >
                        <div class="col">
                            <img
                                src="{{ video.thumbnail }}"
                                alt="{{ video.title }}"
                                class="promotion-image"
                            />
                        </div>
                        <div class="col">
                            <h4>{{ video.url }}</h4>
                            <div>{{ video.title }}</div>
                            <small class="w100">{{ video.description }}</small>
                        </div>
                        <rr-icon
                            class="pointer"
                            name="trash"
                            (click)="removeVideo(i)"
                        ></rr-icon>
                    </div>
                }
            </div>
            <div class="col gap-16 w100">
                <div class="videocontainer card col gap-8 w100">
                    <div class="row space-between align-center w100">
                        <span class="strong">Video</span>
                    </div>
                    <div class="row space-between w100">
                        <input
                            type="file"
                            hidden
                            #videothumbnail
                            (change)="convertImgToBase64($event)"
                        />
                        @if (promotionImageForDisplay) {
                            <img
                                class="promotion-image"
                                [src]="promotionImageForDisplay"
                                alt=""
                            />
                        }
                        <rr-btn size="Small" (click)="videothumbnail.click()"
                            >add Thumbnail</rr-btn
                        >
                    </div>
                    <rr-input
                        label="Video-URL"
                        type="text"
                        [required]="true"
                        #videoulr
                    ></rr-input>
                    <rr-input
                        label="Title"
                        [required]="true"
                        #videotitle
                    ></rr-input>
                    <rr-textarea
                        label="Description"
                        [required]="true"
                        #videodesc
                    ></rr-textarea>
                    <div class="row justify-end w100">
                        <rr-btn
                            (click)="
                                addVideo(
                                    videoulr.FormControl.value,
                                    videotitle.FormControl.value,
                                    videodesc.FormControl.value
                                )
                            "
                            >Save Video</rr-btn
                        >
                    </div>
                </div>
                <div
                    class="emptyhint tiny"
                    *ngIf="
                        !promotionAreaVideos || promotionAreaVideos.length === 0
                    "
                >
                    No videos added yet. Use the "Add Video" button to add one.
                </div>
            </div>
        </div>
        <div>
            <div class="btnrow row gap-8 justify-end w100">
                <rr-btn type="Secondary" (click)="close()">Cancel</rr-btn>
                @if (editMode === false) {
                    <rr-btn
                        type="Primary"
                        iconStart="add"
                        n
                        [disabled]="!formGroup.valid"
                        (click)="!formGroup.valid ? null : saveGenStream()"
                        >Generate Stream</rr-btn
                    >
                } @else {
                    <rr-btn
                        type="Primary"
                        iconStart="save"
                        n
                        [disabled]="!formGroup.valid"
                        (click)="!formGroup.valid ? null : saveGenStream()"
                        >Save Stream</rr-btn
                    >
                }
            </div>
        </div>
    </form>
</div>
